import React from 'react'
import ReportWrapper from '../ReportWrapper'
import PageEmpty from '../../../components/PageEmpty'
import ReportSectionHeading from '../ReportSectionHeading'
import BbgdexCarInfoOverview from './BbgdexCarInfoOverview'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface BbgdexCarInfoProps {
  data: any
  title: string
  sectionIndex?: string
}

type PlateInfo = {
  plateNumber?: string
  plateType?: string
  status?: string
  bindTime?: string
  issueAgency?: string
  [key: string]: any
}

const plateTypeMap: Record<string, string> = {
  small: '小型车辆',
  large: '大型车辆',
  newEnergySmall: '新能源小型车辆',
  newEnergyLarge: '新能源大型车辆',
}

const formatValue = (value?: string | number) => {
  if (value === null || value === undefined || value === '') return '—'
  return String(value)
}

export default function BbgdexCarInfo({ data, title, sectionIndex }: BbgdexCarInfoProps) {
  const theme = useTheme()
  let plates: PlateInfo[] = []

  try {
    const jsonData = JSON.parse(data.bbgdex_car_info ?? '{}')
    plates = jsonData?.plates ?? []
  } catch (error) {
    plates = []
  }

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      {plates.length > 0 && <BbgdexCarInfoOverview plates={plates} />}
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          ETC 车辆绑定信息
        </Text>
        <Stack gap="sm" className="mt-3">
          {plates.length === 0 ? (
            <PageEmpty />
          ) : (
            <Table
              highlightOnHover
              verticalSpacing="sm"
              withColumnBorders={false}
              styles={{
                table: { fontSize: '13px', tableLayout: 'fixed' },
                th: {
                  backgroundColor: theme.surfaceMutedColor,
                  color: theme.accentTextColor,
                  whiteSpace: 'nowrap',
                },
              }}
            >
              <Table.Thead>
                <Table.Tr>
                  <Table.Th style={{ width: '30%' }}>车牌号</Table.Th>
                  <Table.Th style={{ width: '25%' }}>车辆类型</Table.Th>
                  <Table.Th style={{ width: '25%' }}>绑定时间</Table.Th>
                  <Table.Th style={{ width: '20%' }}>状态</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {plates.map((item, index) => (
                  <Table.Tr key={`${item.plateNumber}-${index}`}>
                    <Table.Td>{formatValue(item.plateNumber)}</Table.Td>
                    <Table.Td>{plateTypeMap[item.plateType ?? ''] || formatValue(item.plateType)}</Table.Td>
                    <Table.Td>{formatValue(item.bindTime)}</Table.Td>
                    <Table.Td>{formatValue(item.status)}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
